import { Box, Flex, Button, Text } from '@sparrowengg/twigs-react';
import {
  ChevronLeftIcon,
  ChevronRightIcon
} from '@sparrowengg/twigs-react-icons';
import ActionEnergy from 'commons/icons/action-energy';
import StarIcon from 'commons/icons/star';
import { TooltipRenderProps } from 'react-joyride';
import TickIcon from 'commons/icons/tick';

export const CustomTooltip = ({
  index,
  step,
  backProps,
  primaryProps,
  tooltipProps,
  isLastStep,
  closeProps
}: TooltipRenderProps) => {
  const stepContent = step.content as [];
  return (
    <Box
      {...tooltipProps}
      css={{
        width: 400,
        borderRadius: '$xl',
        background: '#f3f9fa',
        border: '$borderWidths$xs solid $primary400',
        boxShadow: '0px 4px 28px 0px rgba(104, 184, 194, 1)'
      }}
    >
      <Text css={{ color: '$accent400', padding: '$12' }} size="xs">
        {`Step: ${index + 1}/9`}
      </Text>
      <Box css={{ paddingInline: '$12' }}>
        <Flex alignItems="center" gap="$4">
          <ActionEnergy size={24} color="#56B0BB" />
          <Text size="lg" weight="medium">
            {step.title}
          </Text>
        </Flex>
        <Flex flexDirection="column" gap="$6" css={{ paddingTop: '$6' }}>
          {stepContent?.map((content) => {
            return (
              <Flex gap="$4">
                <Flex css={{ width: 14, height: 14, paddingTop: 3 }}>
                  <StarIcon />
                </Flex>
                {content}
              </Flex>
            );
          })}
        </Flex>
      </Box>
      <Flex
        alignItems="center"
        justifyContent={index > 0 ? 'space-between' : 'flex-end'}
        css={{
          padding: '$12',
          background: '$primary100',
          borderRadius: '0 0 $xl $xl',
          marginTop: "$4"
        }}
      >
        {index > 0 && (
          <Button {...backProps} size="md" leftIcon={<ChevronLeftIcon />}>
            Back
          </Button>
        )}
        <Flex alignItems="center" gap="$4">
          <Button
            size="md"
            variant="ghost"
            rightIcon={<ChevronRightIcon />}
            onClick={closeProps.onClick}
          >
            Skip
          </Button>

          <Button
            onClick={primaryProps.onClick}
            size="md"
            rightIcon={
              isLastStep ? (
                <TickIcon size={20} color="#fff" />
              ) : (
                <ChevronRightIcon />
              )
            }
          >
            {isLastStep ? 'Finish Tour' : 'Next'}
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};
